import React, {useEffect, useState} from 'react';
import {Button, Container, Image, Menu as UiMenu, Responsive, Segment} from 'semantic-ui-react';

import {useHistory, NavLink} from 'react-router-dom';

import {City, Languages} from '../';

import {General} from './general'
import {Place} from './place'
import {People} from './people'

let subdomain = window.location.host.split('.')[0];
subdomain = ["italia", "europa"].includes(subdomain) ? "italia" : "geral";

const city = JSON.parse(localStorage.getItem('_CITY'));
const city_id = city['value'];
const token = sessionStorage.getItem('Token');

const getWidth = () => {
    const isSSR = typeof window === 'undefined';

    return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth
};

const getMenu = () => {
    const pathname = window.location.pathname;

    if (pathname.includes('/place/')) {
        return 'place'
    }

    // if (pathname.includes('/people/')) {
    //     return 'people'
    // }

    return 'general';
}

export const Menu = () => {

    const [menu, setMenu] = useState(getMenu)
    const pathname = window.location.pathname;
    const history = useHistory();
    const token = sessionStorage.getItem('Token')

    useEffect(() => {

        async function fetchCategoriesData() {

            console.log(pathname);

            // setMenu('place');
        }

        // noinspection JSIgnoredPromiseFromCall
        fetchCategoriesData()

    }, [pathname])

    return (
        <nav className="main-nav">
            <a href={"/"} onClick={() => {
                if (subdomain === 'geral' && city_id !== 1) {
                    let city = {
                        key: 1,
                        text: "Belo Horizonte",
                        slug: "belo-horizonte",
                        value: 1
                    };

                    localStorage.setItem('_CITY', JSON.stringify(city));

                    window.top.location.href = "/";
                }

                if (subdomain === 'italia' && city_id !== 7) {
                    let city = {
                        key: 7,
                        text: "IN Europa",
                        slug: "in-europa",
                        value: 7
                    };

                    localStorage.setItem('_CITY', JSON.stringify(city));

                    window.top.location.href = "/";
                }

            }}>
                <Image src={`/images/inbh-${subdomain}.jpg`} className="logo-header"/>
            </a>

            <Container className="city-header">
                {
                    menu === 'general' ? <React.Fragment>
                            <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
                                <UiMenu secondary>
                                    <UiMenu.Menu position="right">
                                        {/*{*/}
                                        {/*    !token && <UiMenu.Item>*/}
                                        {/*        <Button*/}
                                        {/*            className={"loginButton"}*/}
                                        {/*            as={NavLink} to={'/users'} content={"Entrar"} />*/}
                                        {/*    </UiMenu.Item>*/}
                                        {/*}*/}
                                        <Languages search={history.location.search}/>
                                        <City subdomain={subdomain}/>
                                    </UiMenu.Menu>
                                </UiMenu>
                            </Responsive>
                            <Responsive getWidth={getWidth} maxWidth={Responsive.onlyMobile.maxWidth}>
                                <UiMenu secondary widths={2}>
                                    <UiMenu.Menu>
                                        <Languages search={history.location.search}/>
                                        <City subdomain={subdomain}/>
                                    </UiMenu.Menu>
                                </UiMenu>
                            </Responsive>
                        </React.Fragment>
                        : <UiMenu secondary/>
                }
            </Container>

            <Segment inverted className={`m-0 menu-${subdomain}`}>
                {menu === 'general' && <General getWidth={getWidth} subdomain={subdomain}/>}
                {menu === 'place' && <Place history={history}/>}
            </Segment>
            {
                (menu === 'general' && token) && <div>
                    <People history={history} />
                </div>
            }

        </nav>
    );
}

export default Menu;
